import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../App";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../../../controls";
import InstantCheckout from "./InstantCheckout";
import { action, controller, Server } from "../../../api/Server";

const CheckoutAction = ({ subTotal }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { settings } = useContext(AppContext);
  const { t } = useTranslation();
  const [cashMethod, setCashMethod] = useState();
  const [isCheckout, setIsCheckout] = useState(false);

  useEffect(() => {
    setIsCheckout(location.pathname === "/pos/checkout");

    Server(controller.PayMethod + action.GetCashMethod).get((res) => {
      if (res && res.status === 200) setCashMethod(res.result);
    });
    return () => {};
  }, [location.pathname]);

  return (
    <div className="d-flex a-center g-10 j-between p-10">
      {!isCheckout && cashMethod?.id && (
        <InstantCheckout {...{ subTotal, cashMethod }} />
      )}

      <Button
        onClick={() => navigate("/pos/checkout")}
        fullWidth
        sx={{
          boxShadow: "var(--shadow-xl) !important",
          fontSize: { lg: "20px", sm: "16px" },
        }}
      >
        {isCheckout ? (
          <div className="d-flex j-between g-10 w-100pr">
            <span>{t("checkout")}</span>
            <span>
              {settings.curSymbol}{" "}
              {parseFloat(subTotal).toFixed(settings.decimal)}
            </span>
          </div>
        ) : (
          t("checkout")
        )}
      </Button>
    </div>
  );
};

export default CheckoutAction;
